import { Button, Container, Spacer, Text, Title } from '@color/continuum';

interface Props {
  error: unknown;
  resetError: () => void;
}

export const NetworkErrorFallback: React.FC<Props> = (props) => {
  const { error, resetError } = props;

  if (!error) {
    return null;
  }

  const onReset = () => {
    resetError();
    window.location.reload();
  };
  return (
    <Container maxWidth="sm">
      <Spacer variant="large" />
      <Title>There’s no internet connection.</Title>
      <Spacer variant="medium" />
      <Text>Try:</Text>
      <Spacer variant="small" />
      <ul>
        <Text>
          <li>Reconnecting to Wi-Fi</li>
          <li>Moving to a place with a better signal</li>
          <li>Checking the network cables, modem, and router</li>
        </Text>
      </ul>
      <Spacer variant="small" />
      <Button variant="color-primary" onClick={onReset}>
        Reload to Try Again
      </Button>
    </Container>
  );
};
